module.exports = __webpack_public_path__ + "static/img/tap_function_aircolor_eu.677d503.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/aircolor/tap_function_aircolor_eu.gif
// module id = 7ev2
// module chunks = 1